import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image109 from "../../../../assets/images/Blog47/image109.png";
import image3 from "../../../../assets/images/Blog47/image3.png";
import image5 from "../../../../assets/images/Blog47/image5.png";
import image40 from "../../../../assets/images/Blog47/image40.png";
import image24 from "../../../../assets/images/Blog47/image24.png";
import image11 from "../../../../assets/images/Blog47/image11.png";
import image12 from "../../../../assets/images/Blog47/image12.png";
import image13 from "../../../../assets/images/Blog47/image13.png";
import image14 from "../../../../assets/images/Blog47/image14.png";
import image6 from "../../../../assets/images/Blog47/image6.png";
import image17 from "../../../../assets/images/Blog47/image17.png";
import image18 from "../../../../assets/images/Blog47/image18.png";
import image52 from "../../../../assets/images/Blog47/image52.png";
import image53 from "../../../../assets/images/Blog47/image53.png";
import image55 from "../../../../assets/images/Blog47/image55.png";
import image56 from "../../../../assets/images/Blog47/image56.png";
import image47 from "../../../../assets/images/Blog47/image47.png";
import image2 from "../../../../assets/images/Blog47/image2.png";
import image62 from "../../../../assets/images/Blog47/image62.png";
import image66 from "../../../../assets/images/Blog47/image66.png";
import image76 from "../../../../assets/images/Blog47/image76.png";
import image39 from "../../../../assets/images/Blog47/image39.png";

const Blog47 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – December 15th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Rates Push Back, AI Leadership Cracks, and Markets Confront the Cost of Capital</p>
        <p>
          What initially looked like a clean post-Fed relief rally faded quickly as markets were forced to confront a familiar problem: rate cuts do not automatically mean easier financial conditions.
          While the Fed delivered the cut the market wanted, long-end yields moved the wrong way, tech leadership buckled, and credit markets once again proved quicker to react than equities.
        </p>
        <p>
          Volatility stayed contained, and broader indices avoided disorderly selling, but the tone beneath the surface shifted meaningfully. AI winners faced their first serious credibility test,
          bond markets tightened financial conditions independently of policy, and flows — while still supportive — became far more selective. This was not panic, but it was a reminder that liquidity
          is no longer free.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Price Resilience, Structural Friction</p>
              <p>
                Equities entered the week well-positioned heading into the Fed, with positioning light and downside hedges elevated. That setup initially worked. Markets absorbed the policy decision
                without stress, and dip buyers remained active.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="pre-Fed market well placed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                However, strength proved fragile once leadership faltered. Friday’s sharp tech sell-off underscored how narrow the market’s tolerance has become for capital-intensive growth stories.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image109}
                    alt="Fri tech slam"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image109)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Oracle became the focal point of that reassessment. Credit markets had already been flagging concern, and equity investors were forced to catch up quickly as questions around cash flow
                durability and capex intensity resurfaced.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="oracle where's the cash flow"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt=" so that is why ORCL was offered"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Flows remain supportive in aggregate, particularly through ETFs, but the character of buying has changed — less indiscriminate, more defensive.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=" ETFs coming from everywhere"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The market is still being held together by flows — but the margin for narrative disappointment is shrinking.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: A Dovish Cut Meets a Hawkish Yield Curve</p>

              <p>
                The Fed delivered the cut markets expected, but the internal story was more complex. Dissents widened, the hawk-dove balance shifted, and the message around future easing was
                noticeably less unified than headlines suggested.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="FOMC full story of the dissidents"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="updated hawks doves"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                While the policy rate moved lower, long-end yields did not cooperate. Instead, Treasury yields pushed higher, tightening financial conditions at the very moment policymakers were
                attempting to ease them.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt="US10Y yield is that a breakout"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=" fed losing long end"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This disconnect matters. As Rosenberg highlighted, markets respond to <span className="highlightedText">price levels,</span> not just inflation rates — and elevated borrowing costs
                continue to pressure duration-sensitive assets.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="Rosenberg focused on prices not just inflation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Globally, the pressure is not isolated. Bond markets across regions remain under strain, reinforcing the idea that fiscal supply and term premium — not policy rates — are driving the
                next phase.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="global bond squeeze"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="global yields in pictures"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Support Holding, Leadership Fading</p>
              <p>From a technical standpoint, broader indices remain intact, but leadership damage is evident.</p>
              <p>The S&P 500 continues to hold above key moving averages, though upside momentum has slowed as gamma dynamics flatten.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image52}
                    alt="SPX 200dma remains solid"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image52)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image53}
                    alt="SPX at key levels"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image53)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Nasdaq, however, closed the week on a weaker footing, slipping below key averages and confirming the rotation away from high-multiple tech.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image55}
                    alt=" nas100 poor close below averages"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image55)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Dow outperformance reflects this shift, with cyclicals and financials benefiting from curve steepening.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image56}
                    alt="Dow has seen it all but could still have a pullback"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image56)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Sentiment indicators remain calm, but pockets of excess remain unresolved.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image47}
                    alt="PC ratio warning of reversal"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image47)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This is a market still supported by structure — but no longer forgiving of valuation or leverage.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Fed Relief, Yield Pushback, and AI Reality Checks</p>
              <p>
                Markets began the week cautiously but stabilised by Friday as the Fed delivered its expected cut, and near-term downside risks eased. However, beneath the surface, rising long-end
                yields and cracks in AI leadership tempered enthusiasm and reinforced the market’s growing sensitivity to the cost of capital.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br> The Fed delivered a rate cut as expected, but the reaction mattered more than the decision itself. While front-end rates eased, long-dated yields pushed higher,
                    tightening financial conditions and undermining the traditional “cuts = risk-on” playbook. Dissents widened, highlighting an increasingly fractured policy backdrop.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image2}
                        alt="Powell the cut"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image2)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image11}
                        alt="FOMC full story of the dissidents"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image11)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Rates & Bonds:</span>
                    <br></br>Treasury yields broke higher across the curve, with the 10Y threatening a technical breakout. The Fed’s inability to control the long end reinforced concerns that fiscal
                    supply and term premium are now driving conditions more than policy intent.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image13}
                        alt="US10Y yield is that a breakout?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image13)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image14}
                        alt="fed losing long end"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image14)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities & AI:</span>
                    <br></br>AI leadership suffered a sharp credibility test. Oracle sat at the centre of the repricing as concerns around capex intensity, delayed cash flow, and data-centre execution
                    resurfaced. The late-week tech selloff confirmed that markets are no longer willing to fund growth stories on narrative alone.
                  </p>
                </li>

                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image3}
                      alt="oracle where's the cash flow?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image3)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt="commodities still cheap"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image109}
                      alt="Fri tech slam"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image109)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Flows: </span>
                    <br></br> ETF inflows remained supportive, cushioning broader indices despite leadership damage. However, the character of buying shifted — more passive, less conviction-driven —
                    leaving markets vulnerable to further yield pressure.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image24}
                      alt=" ETFs coming from everywhere"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image24)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br></br> Gold likes the QE read but paused late in the week as yields rose, entering a wait-and-see phase ahead of clearer liquidity signals. Silver remained volatile following an
                    outsized move, reflecting its sensitivity to shifts in financial conditions, but also higher on supply tightness and JP Morgan buying physical.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image62}
                      alt="gold is waiting to find out"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image62)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image66}
                      alt="silver needs to make history this month"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image66)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br> Bitcoin stabilised after recent volatility, with price holding key support zones. Liquidity conditions, rather than sentiment, remain the dominant driver.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image76}
                        alt=" BTC on Fidelity model support zone"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image76)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Data Digestion, Central Banks, and Bond-Market Risk</p>
              <p>
                A dense macro calendar closes out the final full trading week of the year. With the Fed decision now behind markets, focus shifts to inflation, labour-market follow-through, and a
                heavy slate of global central-bank decisions, all against the backdrop of tightening long-end yields and thinning year-end liquidity.
              </p>
              <p className="highlightedText">Monday, Dec 15</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Japan: Tankan Large Manufacturers & Services</p>
                </li>
                <li className="themesPointer">
                  <p>China: Industrial Production, Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p> China: Fixed Asset Investment, Unemployment Rate</p>
                </li>
                <li className="themesPointer">
                  <p> Eurozone: Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: Rightmove House Price Index</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Empire State Manufacturing Index, NAHB Housing Market Index</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Dec 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Australia: Manufacturing & Services PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>Japan: Manufacturing & Services PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: Labour Market Report (Earnings, Unemployment, Claimant Count)</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: ZEW Economic Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: ADP Employment</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Nonfarm Payrolls (catch-up data)</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Dec 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.K.: CPI, PPI</p>
                </li>
                <li className="themesPointer">
                  <p>Germany: Ifo Business Climate</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: CPI (Final), Wages, Labour Cost Index</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: MBA Mortgage Applications</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Crude Oil Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: 20-Year Treasury Note Auction</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Dec 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.K.: BoE Rate Decision, MPC Vote Split, Minutes, Bailey Speaks</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: ECB Rate Decision, Press Conference</p>
                </li>
                <li className="themesPointer">
                  <p> Japan: BoJ Press Conference</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Philly Fed Index</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Dec 19</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Japan: CPI, BoJ Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: Retail Sales, GfK Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: Business & Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p> U.S.: Core PCE, Personal Income & Spending</p>
                </li>
                <li className="themesPointer">
                  <p> U.S.: Michigan Sentiment</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Policy Cut, Market Pushback</p>
              <p>
                The Fed cut, but the message from markets was clear: easing policy is no longer enough. With term premiums rising and fiscal supply pressuring long rates, the bond market continues to
                dictate risk conditions.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Broader indices remain supported by flows and structure, but leadership is narrowing fast. AI and high-duration names are no longer insulated from balance-sheet scrutiny.
                    Stay selective and respect rotation risk.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold remains structurally constructive but needs yields to stabilise. Silver’s higher beta keeps it volatile,
                    attractive tactically, and dangerous emotionally.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Bitcoin continues to build a base, but upside remains liquidity-dependent. Stability is encouraging; confirmation is
                    still required.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>The cut is done. What matters now is control, or lack thereof, over the long end. If yields continue to rise, financial
                    conditions will tighten regardless of policy intent, capping upside into year-end.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="US equity risk premium warning"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt="gold is waiting to find out"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image76}
                    alt="BTC on Fidelity model support zone"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image76)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">
                  “The bond market rules everybody, and with yields breaking higher, it is setting the limits on how far risk assets can run — regardless of rate cuts.”
                  <br></br>
                  Trade the structure. Respect the cost of capital. Stay nimble.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/11UlQ30qlfeZynA3FXXDCeEzjt_dn3IS2htGNyPuXNqk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog47;
